// purohitConfig.js

export const STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
];

export const SPECIALIZATIONS = [
  "Vivaha Sanskar (Wedding)",
  "Satyanarayan Puja",
  "Kaal Sarp Dosh Puja",
  "Mahamrityunjaya Jaap",
  "Vastu Shanti",
  "Mundan Sanskar",
  "Annaprashan",
  "Griha Pravesh (Housewarming)",
  "Navagraha Shanti",
  "Rudrabhishek",
  "Graha Shanti",
  "Pitru Paksha Rituals",
  "Upanayana Sanskar",
  "Namkaran Sanskar",
];

export const LANGUAGES = [
  "Hindi",
  "English",
  "Sanskrit",
  "Tamil",
  "Telugu",
  "Kannada",
  "Malayalam",
  "Marathi",
  "Bengali",
  "Gujarati",
  "Punjabi",
  "Odia",
];

export const SERVICES = [
  "Wedding Ceremonies",
  "Religious Ceremonies",
  "Remedial Pujas",
  "Life Cycle Rituals",
  "Vastu Consultation",
  "Housewarming Rituals",
  "Astrological Services",
  "Festival Celebrations",
  "Horoscope Analysis",
  "Spiritual Counseling",
];

// SAME regex as in registration
export const regex = {
  name: /^[A-Za-z\s]{3,60}$/,
  email:   /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@gmail\.com$/,
  phone: /^(?:\+91[-\s]?)?[6-9]\d{9}$/,
  pincode: /^[1-9][0-9]{5}$/,
  price: /^[1-9]\d{2,6}$/,
  accountNumber: /^\d{9,18}$/,
  ifsc: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  experience: /^(?:[1-9]\d?|[1-4]\d{2})$/,
  otp: /^[0-9]{4,6}$/,
};
